import * as React from "react";
import { FormattedMessage } from "react-intl";
import { LikeActive, Like } from "common/components/styledComponents";
import { LikeCount, LikeIcon, LikeButton } from "./styledComponents";

const LikeControl = ({
  likesCount,
  isLiked,
  onLikeClick,
  disabled,
  disableDefault,
}: {
  likesCount: number;
  isLiked: boolean;
  onLikeClick: () => void;
  disabled?: boolean;
  disableDefault?: boolean;
}) => {
  return (
    <LikeButton onClick={onLikeClick} disabled={disabled}>
      <LikeIcon>{React.createElement(isLiked ? LikeActive : Like)}</LikeIcon>
      <LikeCount>
        {likesCount ||
          (!disableDefault && <FormattedMessage id="comment_like" />)}
      </LikeCount>
    </LikeButton>
  );
};

export default LikeControl;
